import {Injectable} from '@angular/core';
import { BullhornEntityTypes } from 'datasource-service-lib';
import { AllowedSectionTypes } from './AllowedSectionTypes';
import { IDocMergeAllowedSectionsService } from './IDocMergeAllowedSectionsService';

@Injectable({
  providedIn: 'root',
})
export class BullhornDocMergeAllowedSectionsService implements IDocMergeAllowedSectionsService {
  getAllowedSections(entity: string): AllowedSectionTypes {
    const certificationEntities: string[] = [
      BullhornEntityTypes.Candidate,
      BullhornEntityTypes.JobSubmission,
      BullhornEntityTypes.Placement
    ];
    const certificationsAllowed = certificationEntities.includes(entity);
    return new AllowedSectionTypes(certificationsAllowed, true, true, true);
  }
}
